/**
 *  Created by Rodrigo de Miguel for project Adopta-un-animal/AdoptaUnAnimal on 30/12/2022
 *
 */

export function getCurrentLocationCoordinatesPromise() {
    return new Promise(
        (resolve, reject) => {
            // //console.log("GeoCoding::getCurrentLocationPromise()");
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        resolve(position);
                    },
                    () => {
                        handleLocationError(true)
                        return reject(undefined);
                    }
                );
            } else {
                // Browser doesn't support Geolocation
                handleLocationError(false)
                return reject(undefined);
            }
        });
}

export function getCurrentLocationCoordinates(successCallBack, errorCallback, Alert) {
    // console.log("getCurrentLocationCoordinates::getCurrentLocationCoordinates()");
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                successCallBack(position)
            },
            () => {
                // console.log("call errorCallback");
                errorCallback(true, Alert)
            }
        );
    } else {
        // Browser doesn't support Geolocation
        // console.log("call errorCallback");
        errorCallback(false, Alert)
    }
}

export function handleErrorCurrentLocationCoordinates(browserHasGeolocation, Alert) {
    let errorGetGeoLocation = browserHasGeolocation
        ? "Error: El servicio de geolocalización falló."
        : "Error: Tu navegador no soporta la geolocalización."
    
    // Alert.error(errorGetGeoLocation, {
    //     position: 'top-right',
    //     effect: 'slide',
    //     timeout: 5000,
    //     customFields: {
    //         messageItem: 2,
    //         showIconClosed: true,
    //         icon: "las la-2x la-exclamation-triangle"
    //     }
    // });
    
    let elements = document.querySelectorAll(".buttonBuscarCerca >i")
    if (elements) {
        elements.forEach((element) => {
            element.classList.remove('spin');
            element.classList.remove('la-sync-alt');
            element.classList.add('la-crosshairs');
        })
    }
    
}


// Función que calcula la distancia entre dos coordenadas devuelta en KM
export function coordsDistance(meineLongitude, meineLatitude, long1, lat1) {
    const erdRadius = 6371;
    meineLongitude = meineLongitude * (Math.PI / 180);
    meineLatitude = meineLatitude * (Math.PI / 180);
    long1 = long1 * (Math.PI / 180);
    lat1 = lat1 * (Math.PI / 180);
    const x0 = meineLongitude * erdRadius * Math.cos(meineLatitude);
    const y0 = meineLatitude * erdRadius;
    const x1 = long1 * erdRadius * Math.cos(lat1);
    const y1 = lat1 * erdRadius;
    const dx = x0 - x1;
    const dy = y0 - y1;
    const d = Math.sqrt((dx * dx) + (dy * dy));
    // return Math.round(d);
    return d;
}